module.exports = new __parcel__URL__("FS.674b3966.jpg").toString();